import { Pipe, PipeTransform } from '@angular/core';

/**
 * Humanises the canonical reason strings persisted in
 * preferred_partner_carrier_weekly_eligibility.details.reason. Source of
 * truth for the constants is agnus-server/preferredPartner/eligibility/carrier.go
 * (lines 79-86) plus the lohi-server-only `region_not_in_program` sentinel.
 *
 * Unknown reasons fall through verbatim so a new evaluator label still
 * renders something sensible while we patch the pipe.
 */
@Pipe({ name: 'carrierReason' })
export class CarrierReasonPipe implements PipeTransform {
  private static readonly map: Record<string, string> = {
    passed_weekend_hitch_rule: 'Passed weekend hitch rule',
    passed_daily_capacity_rule: 'Passed daily capacity rule',
    passed_both_rules: 'Passed both rules',
    failed_both_rules: 'Failed both rules',
    no_active_roster_in_region: 'No active roster in this region',
    weekend_only_carrier: 'Weekend-only carrier (skipped)',
    region_not_in_program: 'Region not in program yet',
    override_without_original_details: 'Manual override (no original verdict)',
    override_with_unparseable_original_details: 'Manual override (corrupt original)',
    override_chain_exceeded_max_depth: 'Override chain too deep',
  };

  public transform(reason: string | null | undefined): string {
    if (!reason) {
      return '';
    }
    return CarrierReasonPipe.map[reason] ?? reason;
  }
}
